// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"988d8383","230":"90d7d557","405":"f7110ba0","578":"7419205b","629":"4db4193a","912":"ed082382"}[chunkId] + ".chunk.css";
};